import { Button, Collapse, Container, createMuiTheme, Divider, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { InvertedChevronIcon } from 'components/Icons';
import Loading from 'components/Loading';
import PrivateContainer from 'components/PrivateContainer';
import { basePath } from 'library/Routes';
import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { assembleiasAssociadoActionsLoadAll, assembleiasAssociadoActionsLoadDemaisAssembleias } from 'store/modules/AssembleiasAssociadoActions';
import { IAssembleiaAssociado } from 'store/modules/AssembleiasAssociadoReducer';
import { IReducer } from 'store/Reducer';
import AxiosErrorHandler from 'utils/AxiosErrorHandler';
import CartaoEvento from './CartaoEvento';
import useStyles from './styles';

export default function () {
  const { t } = useTranslation();
  const classes = useStyles();
  const [openedDemaisAssembleias, setOpenedDemaisAssembleias] = useState<boolean>(false);
  const theme = createMuiTheme();
  const isLargeMediaQuery: string = `(min-width: ${theme.breakpoints.values.md}px)`;
  const isLarge = useMediaQuery(isLargeMediaQuery);
  const {all, loadingAll, demaisAssembleias, loadingDemaisAssembleias} = useSelector((state: IReducer) => state.assembleias);
  const dispatch = useDispatch();
  const [minhasAssembleiasLoaded, setMinhasAssembleiasLoaded] = useState<boolean>();
  const [demaisAssembleiasLoaded, setDemaisAssembleiasLoaded] = useState<boolean>();

  const minhasAssembleias = useMemo<IAssembleiaAssociado[]>(() => {
    return all;
  }, [all])

  const loadingMinhasAssembleias = useMemo<boolean>(() => {
    return loadingAll;
  }, [loadingAll])

  useEffect(() => {
    dispatch(assembleiasAssociadoActionsLoadAll(
      () => setMinhasAssembleiasLoaded(true),
      AxiosErrorHandler
    ))
    dispatch(assembleiasAssociadoActionsLoadDemaisAssembleias(
      () => setDemaisAssembleiasLoaded(true),
      AxiosErrorHandler
    ))
  }, [dispatch])

  useEffect(() => {
    if (minhasAssembleiasLoaded && demaisAssembleiasLoaded) {
      if (all.length === 0 && demaisAssembleias.length > 0) {
        setOpenedDemaisAssembleias(true);
      } 
    }
  }, [minhasAssembleiasLoaded, demaisAssembleiasLoaded, all, demaisAssembleias])

  const getAssembleiasHeader = useCallback((mine: boolean) => {
    const translationAddress: string = `TelaInicialAssociado.${mine ? 'minhasAssembleias' : 'demaisAssembleias'}.`;
    const content = (
      <div>
        <Typography component="h5" className={classes.assembleiasTitle}>
          {t(`${translationAddress}title`)}
        </Typography>
        <Typography component="p" className={classes.assembleiasSubtitle}>
          {t(`${translationAddress}subtitle`)}
        </Typography>
      </div>
    )
    if (mine) {
      return (
        <Grid item  sm={12}>
          {content}
        </Grid>
      )
    }
    return (
      <Fragment>
        <Grid item sm={6} md={4}>
          {content}
        </Grid>
        <Grid item sm={6} md={4}>
          <Button
            variant="text"
            color="primary"
            endIcon={
              <InvertedChevronIcon className={[
                classes.chevronIcon,
                openedDemaisAssembleias ? classes.openedChevronIcon : '',
              ].join(' ')} />
            }
            onClick={() => setOpenedDemaisAssembleias(!openedDemaisAssembleias)}
          >
            {t(`TelaInicialAssociado.demaisAssembleias.${openedDemaisAssembleias ? 'seeLess' : 'seeMore'}`)}
          </Button>
        </Grid>
      </Fragment>
    )
  }, [t, classes, openedDemaisAssembleias, setOpenedDemaisAssembleias])

  return (
    <PrivateContainer>
      <Container maxWidth="xl">
        <Grid container spacing={3} className={classes.content}>
          <Grid item sm={12} md={8} className={classes.leftSide}>
            <Typography component="p" className={classes.descriptionHighlight}>
              {t('TelaInicialAssociado.descriptionHighlight')}
            </Typography>
            <Typography component="p" className={classes.description}>
              {t('TelaInicialAssociado.description')}
            </Typography>
            <div style={{flex: 1}}></div>
            {
              !(loadingMinhasAssembleias || loadingDemaisAssembleias) && isLarge && (minhasAssembleias.length > 0 || demaisAssembleias.length > 0) && (
                <Fragment>
                  <Divider />
                  <Grid container spacing={3} className={classes.largeAssembleiasHeader}>
                    {getAssembleiasHeader(minhasAssembleias.length > 0)}
                  </Grid>
                </Fragment>
              )
            }
          </Grid>
          <Grid item sm={12} md={4} className={classes.rightTextContent}>
            <img
              src={`${basePath}images/poslogado.png`}
              alt=""
              className={classes.rightImage}
            />
            {/* <Typography component="h3" className={classes.rightText}>
              {t('TelaInicialAssociado.rightText')}
            </Typography> */}
          </Grid>
          {
            loadingMinhasAssembleias || loadingDemaisAssembleias ? (
              <Loading text={t('TelaInicialAssociado.loadingAssembleias')} />
            ) : (
              <Fragment>
                {
                  minhasAssembleias.length > 0 && (
                    <Grid item xs={12}>
                      <Grid container spacing={3}>
                        {
                          !isLarge && getAssembleiasHeader(true)
                        }
                        {
                          minhasAssembleias.map(
                            (it: IAssembleiaAssociado, key: number) => (
                              <Grid item sm={6} md={4} key={key}>
                                <CartaoEvento evento={it} />
                              </Grid>
                            )
                          )
                        }
                      </Grid>
                    </Grid>
                  )
                }
                {
                  demaisAssembleias.length > 0 && (
                    <Grid item xs={12} className={minhasAssembleias.length > 0 || !isLarge ? classes.demaisAssembleiasWrapper : ''}>
                      <Grid container spacing={3}>
                        {
                          (minhasAssembleias.length > 0 || !isLarge) && (
                            <Grid item xs={12}>
                              <Grid container alignItems="center">
                                {getAssembleiasHeader(false)}
                              </Grid>
                            </Grid>
                          )
                        }
                        <Grid item xs={12}>
                          <Collapse in={openedDemaisAssembleias}>
                            <Grid container spacing={3}>
                              {
                                demaisAssembleias.map(
                                  (it: IAssembleiaAssociado, key: number) => (
                                    <Grid item sm={6} md={4} key={key}>
                                      <CartaoEvento evento={it} />
                                    </Grid>
                                  )
                                )
                              }
                            </Grid>
                          </Collapse>
                        </Grid>
                      </Grid>
                    </Grid>
                  )
                }
              </Fragment>
            )
          }
        </Grid>
      </Container>
    </PrivateContainer>
  );
}
